<template>
  <div class="view contentBody">
    <div class="title">推广路径</div>
    <div class="titleLine mb-20">
      <p class="titleLine_title">推广路径用途 </p>
      <p class="titleLine_desc">可导出各页面小程序码常用于企业广告及宣传推广，链接可用于公众号内推广。 用户通过推广路径访问小程序时，如有浏览过名片则进入上一次浏览的名片，如没有则随机进入默认名片  </p>
    </div>
    <div class="content">
      <div class="content-tab-box mb-20">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item" 
                   @refreshFn="refreshFn"></component>
        <!-- <component v-bind:is="item" v-if="meaulistTab.firstTab==item" :pageStatus.sync="pageStatus"
                   @refreshFn="refreshFn"></component>                    -->
      </div>
    </div>
  </div>
</template>
<script>
  import extensionGoods from "./extensionGoods.vue";
  import extensionSmall from "./extensionSmall.vue";
  let tabBox = {
    '小程序界面': {property: 'extensionSmall'},
    '商品': {property: 'extensionGoods'}
  }
  export default {
    name: "card",
    components: {
      extensionGoods,
      extensionSmall
    },
    data() {
      return {
        activeName: '',
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "cardlist";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      },
      refreshFn() {
        
      }
    }
  };
</script>
